/* eslint-disable max-len */
import React, { Fragment, useRef, useState} from 'react';
import 'tw-elements';
import TableBody from './TableBody';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import {  useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

const Table = ({
    pageNumber, 
    setConfirmationState, 
    handleSidePopupClick,
    searchParams,
    approveTriminate,
    handleTerminateStudent,
    setSearchParams,
    selectedIndex, 
    setSelectedIndex,
    ongoingAYName,
    email,setLoading}) => {
    const dispactch=useDispatch()
    const selectedRef = useRef();
    const StudentsDirectoryList = useSelector(state => state.StudentsDirectorySlice);
    const { List } = StudentsDirectoryList
    let NoOfStudents = ["10", "20", "30", "40", "50"];
    const urlParams = new URLSearchParams(window.location.search);
    
    
    /* `useOnClickOutside` is a custom hook that takes two arguments: a ref and a callback function. It
    is used to detect clicks outside of a specific element (in this case, the `selectedRef` element)
    and trigger the callback function (`setSelectedIndex(null)`) when a click is detected outside of
    that element. In this specific code, it is used to close a dropdown menu when a user clicks
    outside of it. */
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });

    /**
     * The function updates the search parameters with a new limit value and sets the page number to 1,
     * then triggers a loading state.
     */
    function handleNoOfRowsClick(number) {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
  
    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;

    return (<>
        <div class="flex justify-between">
            <div class="flex justify-start items-center pb-2 mr-[5px] ml-2">
                {ongoingAYName && <p class="font-normal text-[#052136]">Academic Year: <span class='font-semibold'>{ongoingAYName}</span></p>}
            </div>
            <div class="flex justify-end items-center pb-2 mr-[5px]">
                <p class="font-normal text-[#052136]">No. of students per page:</p>
                <ul class="flex items-center ml-2">
                    {NoOfStudents.map((number)=>(
                        <li key={number}>
                            <p 
                                className={`text-xs font-semibold ${searchParams.get('limit')===number?"bg-[#106EB4] text-[#EEF7FE] p-1":"text-[#052136]"}  rounded mr-2 cursor-pointer`}
                                onClick={()=>handleNoOfRowsClick(number)}
                            >
                                {number}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
        
        <div className={`flex overflow-auto ${List?.students?.length < 10 ? 'pb-[130px]' : 'pb-[6px]'} scroll-bar px-1`} id = "search-result" >
            <table aria-label="Outside Table" className="w-full noborder" id='admin-table'>
                <tbody>
                    {List?.students?.map((item , index = 0) => (
                        <Fragment key={item._id}>
                            <TableBody
                                tableData={item}
                                setConfirmationState={setConfirmationState}
                                indexNum={index}
                                pageNumber={pageNumber}
                                selectedIndex={selectedIndex}
                                setSelectedIndex={setSelectedIndex}
                                selectedRef={selectedRef}
                                lastIndex={List?.students?.length}
                                email={email}
                                approveTriminate={approveTriminate}
                                handleTerminateStudent={handleTerminateStudent}
                                searchParams={searchParams}
                                setSearchParams={setSearchParams}
                                handleSidePopupClick={handleSidePopupClick}
                            />
                        </Fragment>
                    ))}
                        
                </tbody>
                {List?.students?.length === 0 && (
                    <tbody className={'applyShadow'}>
                        <tr className={'applyShadow'}>
                            <td  style={{'line-height':'135px'}} colspan="14" className="no-records-message inline left-[40%] relative">
                                {noSearchOrFilter ? `No students added yet.` : 'No matching records found.'}
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>
        </div>

    </>
    );
}

export default Table;
